'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('./../../external/classnames/index.js');
var PropTypes = require('prop-types');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

/**
 *
 * @param {object} props
 * @param {string} [props.backgroundColor] - The background color for transparency
 * @param {import('react').ReactNode} [props.children] - The content to be displayed over the image
 * @param {string} [props.className] - Additional classes to be added to the hero
 * @param {string} props.img - The image to be displayed
 * @param {{sizes: string, srcSet: string}} props.imgSrcSet - The srcSet and sizes for the image
 * @param {HTMLImageElement['loading']} [props.loading] - The loading attribute for the image
 * @returns {JSX.Element}
 */

var HeroSrcSet = function HeroSrcSet(props) {
  var _props$backgroundColo = props.backgroundColor,
    backgroundColor = _props$backgroundColo === void 0 ? 'rgba(0,0,0,.5)' : _props$backgroundColo,
    children = props.children,
    className = props.className,
    img = props.img,
    imgSrcSet = props.imgSrcSet,
    loading = props.loading;
  var classes = index.default('lanl-hero-src-set', className);
  return /*#__PURE__*/React__default.default.createElement("div", {
    className: classes,
    "data-testid": "hero"
  }, /*#__PURE__*/React__default.default.createElement("img", {
    srcSet: imgSrcSet === null || imgSrcSet === void 0 ? void 0 : imgSrcSet.srcSet,
    src: img,
    sizes: imgSrcSet === null || imgSrcSet === void 0 ? void 0 : imgSrcSet.sizes,
    alt: "",
    className: "lanl-hero-image-src-set",
    loading: loading
  }), /*#__PURE__*/React__default.default.createElement("div", {
    className: "lanl-hero-container-src-set",
    style: {
      backgroundColor: backgroundColor
    }
  }, children));
};
HeroSrcSet.defaultProps = {
  backgroundColor: 'rgba(0,0,0,.5)'
};
HeroSrcSet.propTypes = {
  img: PropTypes__default.default.string.isRequired,
  imgSrcSet: PropTypes__default.default.shape({
    sizes: PropTypes__default.default.string,
    srcSet: PropTypes__default.default.string
  }).isRequired,
  backgroundColor: PropTypes__default.default.string,
  children: PropTypes__default.default.node,
  className: PropTypes__default.default.string,
  loading: PropTypes__default.default.oneOf(['eager', 'lazy'])
};

exports.HeroSrcSet = HeroSrcSet;
exports.default = HeroSrcSet;
//# sourceMappingURL=HeroSrcSet.js.map
